import React, { useState } from 'react';
import {
  Accordion, AccordionDetails, AccordionSummary, Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';
import { DropzoneArea } from 'react-mui-dropzone';
import SettingsMenu from './components/SettingsMenu';
import EditItemView from './components/EditItemView';
import { useTranslation } from '../common/components/LocalizationProvider';
import SelectField from '../common/components/SelectField';
import { useCatch } from '../reactHelper';

const useStyles = makeStyles((theme) => ({
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
}));

const VehiclePage = () => {
  const classes = useStyles();
  const t = useTranslation();

  const [item, setItem] = useState();

  const validate = () => item && item.name;
  const [vehicleCategories] = useState(['Sedan', 'SUV', 'Pickup Truck', 'Van', 'Bus', 'Box Truck', 'Trailer Truck']);

  const handleFiles = useCatch(async (files) => {
    if (files.length > 0) {
      const formData = new FormData();
      formData.append('file', files[0]);
      const response = await fetch('/api/file', {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) {
        throw Error(await response.text());
      } else {
        setItem({ ...item, imageName: files[0].name });
      }
    }
  });

  return (
    <EditItemView
      endpoint="vehicles"
      item={item}
      setItem={setItem}
      validate={validate}
      menu={<SettingsMenu />}
      breadcrumbs={['settingsTitle', 'vehicleDialog']}
    >
      {item && (
      <>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1">
              {t('general')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.details}>
            <TextField
              value={item.name || ''}
              onChange={(event) => setItem({ ...item, name: event.target.value })}
              label={t('sharedName')}
            />
            <SelectField
              value={item.category || ''}
              onChange={(event) => setItem({ ...item, category: event.target.value })}
              keyGetter={(it) => it}
              titleGetter={(it) => it}
              values={vehicleCategories}
              label={t('category')}
            />
            <TextField
              value={item.make || ''}
              onChange={(event) => setItem({ ...item, make: event.target.value })}
              label={t('make')}
            />
            <TextField
              value={item.model || ''}
              onChange={(event) => setItem({ ...item, model: event.target.value })}
              label={t('model')}
            />
            <TextField
              type="number"
              value={item.year || ''}
              onChange={(event) => setItem({ ...item, year: event.target.value })}
              label={t('year')}
            />
            <TextField
              value={item.vin || ''}
              onChange={(event) => setItem({ ...item, vin: event.target.value })}
              label={t('vin')}
            />
            <TextField
              value={item.licensePlateNumber || ''}
              onChange={(event) => setItem({ ...item, licensePlateNumber: event.target.value })}
              label={t('licensePlateNumber')}
            />
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1">
              {t('attributeImage')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.details}>
            <DropzoneArea
              dropzoneText={t('sharedDropzoneText')}
              acceptedFiles={['image/*']}
              filesLimit={1}
              onChange={handleFiles}
              showAlerts={false}
            />
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1">
              {t('associations')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.details}>
            <SelectField
              value={item.deviceId || 0}
              onChange={(event) => setItem({ ...item, deviceId: Number(event.target.value) })}
              endpoint="/api/devices"
              label={t('sharedDevice')}
            />
            <SelectField
              value={item.driverId || 0}
              onChange={(event) => setItem({ ...item, driverId: Number(event.target.value) })}
              endpoint="/api/drivers"
              label={t('sharedDriver')}
            />
          </AccordionDetails>
        </Accordion>
      </>
      )}
    </EditItemView>
  );
};

export default VehiclePage;
